import { useState } from 'react';
import { InView } from 'react-intersection-observer';
import ReactPlayer from 'react-player';
import Playbutton from '@public/assets/svg/Playbutton.svg';
import { BLACK_POSTER_IMAGE_VIDEO } from '@utils/data';
import { useStyles } from './useStyles';

interface VideoPlayerSectionProps {
  videoUrl?: string;
  posterImgUrl?: string;
  autoPlay?: boolean;
  height?: string;
  isControl?: boolean;
}

const VideoPlayerSection = (props: VideoPlayerSectionProps) => {
  const {
    videoUrl = 'https://www.youtube.com/watch?v=CGEcUgZT350',
    posterImgUrl = BLACK_POSTER_IMAGE_VIDEO,
    autoPlay = true,
    height,
    isControl = false,
  } = props;

  const [start, setStart] = useState<boolean>(false);
  const [isAutoplay, setAutoPlay] = useState<boolean>(true);
  const [play, setPlay] = useState<boolean>(false);

  const classes = useStyles();

  const onVisible = (inView: boolean) => {
    if (!inView && (isAutoplay || play)) {
      if (autoPlay) {
        setAutoPlay(false);
      } else {
        setPlay(false);
      }
    } else {
      if (autoPlay) {
        setAutoPlay(true);
      } else {
        //setPlay(true);
      }
    }
  };

  const onStart = () => {
    setStart(true);
    if (autoPlay) {
      setAutoPlay(true);
    } else {
      setPlay(true);
    }
  };

  const onPlay = () => {
    if (autoPlay) {
      setAutoPlay(true);
    } else {
      setPlay(true);
    }
  };

  const onClick = () => {
    if (autoPlay) {
      setAutoPlay(true);
    } else {
      setPlay(true);
    }
  };

  return (
    <>
      {autoPlay ? (
        <InView
          threshold={0.5}
          onChange={(inView: boolean) => onVisible(inView)}
          className={classes.autoPlayerWrapper}
        >
          <ReactPlayer
            url={videoUrl}
            playsinline
            playing={isAutoplay}
            loop
            muted
            controls={isControl}
            autoPlay
            width="100%"
            height="100%"
          />
        </InView>
      ) : (
        <InView
          threshold={0.5}
          onChange={(inView: boolean) => onVisible(inView)}
          className={classes.playerWrapper}
          style={{ height: height || '100%' }}
        >
          <ReactPlayer
            url={videoUrl}
            playsinline
            playing={play}
            controls
            light={posterImgUrl}
            width="100%"
            height="100%"
            // objectFit="cover"
            // layout="intrinsic"
            playIcon={<Playbutton />}
            onStart={onStart}
            onPlay={onPlay}
            onClickPreview={onClick}
          />
        </InView>
      )}
    </>
  );
};

export default VideoPlayerSection;
